export default function () {
  const clipboardButtons = document.querySelectorAll('.clipboard-btn');

  clipboardButtons?.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const valueFieldName = button.getAttribute('data-field-name');
      const valueField = document.querySelector('.clipboard-value[name="' + valueFieldName + '"]');

      let bufferValue = '';

      if (valueField.value) {
        bufferValue = valueField.value;
      } else {
        bufferValue = valueField.getAttribute('data-default-value');
      }

      if (!bufferValue) {
        return;
      }

      const buttonTextElement = button.querySelector('.clipboard-btn-text');

      const beforeText = button.getAttribute('data-before-text');

      if (beforeText) {
        bufferValue = beforeText + bufferValue;
      }

      navigator.clipboard.writeText(bufferValue)
        .then(() => {
          if (buttonTextElement.innerText !== 'Скопировано!') {
            const originalText = buttonTextElement.innerText;

            buttonTextElement.innerText = 'Скопировано!';
            setTimeout(() => {
              buttonTextElement.innerText = originalText;
            }, 1500);
          }
        })
        .catch((error) => {
          const pageErrorWrapper = document.querySelector('.action-status-messages');
          if (pageErrorWrapper) {
            pageErrorWrapper.innerHTML = '<div class="alert alert_error">При копировании возникла ошибка</div>';
          }
        });
    });
  });
}
